import { useCallback, useRef } from 'react';
import { useRouter } from 'next/router';
import { clearAuthReturnPath, getAuthReturnPath, getSafeAuthReturnPath } from '@/libs/authReturnPath';

export const useAuthReturnRedirect = (returnTo?: string | string[]) => {
  const { replace } = useRouter();
  const returnPathRef = useRef<string | null>(null);
  const redirectRef = useRef<Promise<void> | null>(null);
  const requestedReturnPath = getSafeAuthReturnPath(returnTo);

  return useCallback(() => {
    if (redirectRef.current) return redirectRef.current;

    returnPathRef.current ??= getAuthReturnPath(requestedReturnPath ?? undefined);
    redirectRef.current = replace(returnPathRef.current)
      .then(() => {
        clearAuthReturnPath();
      })
      .catch((error) => {
        redirectRef.current = null;
        throw error;
      });

    return redirectRef.current;
  }, [replace, requestedReturnPath]);
};
